module.exports = __webpack_public_path__ + "static/img/qr.0cfe2b47.png";